(function(root, undefined) {

	let lib = {};

	const isString = lib.isString = function(stringToCheck) {
		return typeof stringToCheck === 'string' || stringToCheck instanceof String;
	}

	const isFunction = lib.isFunction = function(functionToCheck) {
		return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
	}

	const isEmpty = lib.isEmpty = function(val) {
		return val === undefined || val === null || val === '';
	};

	const strStartsWith = lib.strStartsWith = function(str, prefix) {
		return str.indexOf(prefix) === 0;
	};

	const strEndsWith = lib.strEndsWith = function(str, suffix) {
		return str.indexOf(suffix, this.length - suffix.length) !== -1;
	};

	const strContains = lib.strContains = function(str, needle) {
		return str.indexOf(needle) !== -1;
	};

	const strPad = lib.strPad = function(pad, str) {
		return pad.substring(0, pad.length - str.length) + str;
	};

	const escapeHtml = lib.escapeHtml = function (str) {
		return str.replace(/[&<>"'\/]/g, function (s) {
			const entityMap = {
				"&": "&amp;",
				"<": "&lt;",
				">": "&gt;",
				'"': '&quot;',
				"'": '&#39;',
				"/": '&#x2F;'
			};
			return entityMap[s];
		});
	}

	const unescapeHtml = lib.unescapeHtml = function(str) {
			return jQuery('<div />').html( str ).text();
	}

	const strParseDecimal = lib.strParseDecimal = function(str) {
		const commaIndex = str.lastIndexOf(',');
		const pointIndex = str.lastIndexOf('.');
		let separateIndex;

		if(commaIndex !== -1 && pointIndex !== -1) {
			separateIndex = commaIndex > pointIndex ? commaIndex : pointIndex;
		} else if(commaIndex !== -1) {
			separateIndex = commaIndex;
		} else {
			separateIndex = pointIndex !== -1 ? pointIndex : -1;
		}

		let before;
		let after;

		if(separateIndex !== -1) {
			before = str.substr(0,separateIndex);
			after = str.substr(separateIndex);
		} else {
			before = str;
			after = "0";
		}
		return parseFloat(before.replace(/\D/, "") + "." + after.replace(/\D/, ""));
	};

	/**
	 * @param {Object} [obj]
	 */
	const toQueryString = lib.toQueryString = function(obj) {
		let parts = [];
		for (let i in obj) {
			if (obj.hasOwnProperty(i) && !isEmpty(obj[i])) {
				parts.push(encodeURIComponent(i) + "=" + encodeURIComponent(obj[i]));
			}
		}
		return parts.join("&");
	};

	/**
	 * @param {string} queryString
	 */
	const fromQueryString = lib.fromQueryString = function(queryString) {
		let vars = [];

		// Get the start index of the query string
		const qsi = queryString.indexOf('?');

		let qs = (qsi === -1) ? queryString : queryString.slice(qsi+1);

		// Check if there is a subsection reference
		const sri = qs.indexOf('#');
		if (sri >= 0)
			qs = qs.slice(0, sri);

		// Build the associative array
		const hashes = qs.split('&');
		for (let i = 0; i < hashes.length; i++) {
			const sep = hashes[i].indexOf('=');
			if (sep <= 0)
				continue;
			const key = decodeURIComponent(hashes[i].slice(0, sep));
			vars[key] = decodeURIComponent(hashes[i].slice(sep + 1));
		}

		return vars;

	}

	const removeSecureTokenFromBrowserUrl = lib.removeSecureTokenFromBrowserUrl = function() {
		if (window.history.replaceState) {
			const currentUrl = window.location.href;
			const lastSegment = currentUrl.substring(currentUrl.lastIndexOf('/') + 1);
			const secureUuidPattern = new RegExp("^[0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12}$");
			const secureTokenPattern = new RegExp("^[0-9a-fA-F]{32}$");
			if (secureUuidPattern.test(lastSegment) || secureTokenPattern.test(lastSegment)) {
				let newUrl = currentUrl.substring(0, currentUrl.lastIndexOf('/'));
				window.history.replaceState({path: newUrl}, '', newUrl);
			}
		}
	}

	const clone = lib.clone = function(obj) {
		if (null == obj || "object" != typeof obj) return obj;
		const copy = obj.constructor();
		for (const attr in obj) {
			if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
		}
		return copy;
	};

	const getUUID = lib.getUUID = function () {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			const r = Math.random()*16|0, v = c === 'x' ? r : (r&0x3|0x8);
			return v.toString(16);
		});
	};

	const formatFileSize = lib.formatFileSize = function(bytes) {
		if (typeof bytes !== 'number') return '';
		if (bytes >= 1000000000) return (bytes / 1000000000).toFixed(2) + ' GB';
		if (bytes >= 1000000) return (bytes / 1000000).toFixed(2) + ' MB';
		return (bytes / 1000).toFixed(2) + ' KB';
	};

	/**
	 * @param {string} url
	 * @param {Object} [params]
	 */
	const getUrl = lib.getUrl = function(url, params) {
		let result = !strStartsWith(url, "/") && !strStartsWith(url, "http") ? rootPath + url : url;
		const querystring = toQueryString(params);
		if(querystring !== '') {
			if(result.indexOf('?') === -1) result += '?';
			result += querystring;
		}
		return result;
	};

	const isHardwareMobileDevice = lib.isHardwareMobileDevice = function() {
		let check = false;
		(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
		return check;
	}

	const isHardwareCamera = lib.isHardwareCamera = new Promise((resolve, reject) => {
		// First, check if the mediaDevices support is present
		if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
			reject(new Error('enumerateDevices() not supported.'));
			return;
		}

		// List all the media devices
		navigator.mediaDevices.enumerateDevices()
			.then(devices => {
				// Check if there's any videoinput device (camera)
				const hasCameraDevice = devices.some(device => device.kind === 'videoinput');
				resolve(hasCameraDevice);
			})
			.catch(err => {
				reject(err);
			});
	});

	/**
	 * @param {string} action
	 * @param {string|function|Object} [params] Query String, oder Function oder {}
	 */
	const postActionText = lib.postActionText = async function(action = '', params) {
		let postBody;
		if(isString(params)) {
			postBody = params;
		} else if(isFunction(params)) {
			postBody = params.call();
		} else {
			postBody = toQueryString(params);
		}

		const response = await fetch((!strStartsWith(action, "/") ? rootPath : '') + action, {
			method: 'POST',
			cache: 'no-cache',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			},
			body: postBody
		});
		return response.text();
	};

	/**
	 * @param {string} action
	 * @param {string|function|Object} [params] Query String, oder Function oder {}
	 */
	const postAction = lib.postAction = async function(action = '', params) {
		let postBody;
		if(isString(params)) {
			postBody = params;
		} else if(isFunction(params)) {
			postBody = params.call();
		} else {
			postBody = toQueryString(params);
		}

		const response = await fetch((!strStartsWith(action, "/") ? rootPath : '') + action, {
			method: 'POST',
			cache: 'no-cache',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			},
			body: postBody
		});
		return response.json()
			.then( function(data) {

				if(data.sessionExpired && $('.frm-login').length === 0) {
					window.location.href=util.getUrl("index", {'LOGIN_LOGOUT': '2'});
					return;
				}

				if(validationaware.hasErrors(data)) {
					validationaware.updateUiErrors(data);
				}
				return data;
			});
	};

	const serializedArrayToForm = lib.serializedArrayToForm = function(formArray) {
		let returnArray = {};
		for (let i = 0; i < formArray.length; i++){
			returnArray[formArray[i]['name']] = formArray[i]['value'];
		}
		return returnArray;
	};

	const postNdJson = lib.postNdJson = async function(action, params, resultfn, onStreamComplete) {
		const decoder = new TextDecoder();
		let buf = '';

		let postBody;
		if (isString(params)) {
			postBody = params;
		} else if (isFunction(params)) {
			postBody = params.call();
		} else {
			postBody = toQueryString(params);
		}

		const resource = (!strStartsWith(action, "/") ? rootPath : '') + action;
		const init = {
			method: 'POST',
			cache: 'no-cache',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			},
			body: postBody
		};

		const resp = await fetch(resource, init);
		const reader = resp.body.getReader();

		async function process({value, done}) {
			if (done) {
				resultfn(JSON.parse(buf));
				return;
			}

			buf += decoder.decode(value, {stream: true});
			const lines = buf.split(/[\r\n](?=.)/);
			buf = lines.pop();
			lines.map(JSON.parse).forEach(resultfn);

			return await reader.read().then(process);
		}

		await reader.read().then(process);

		if (isFunction(onStreamComplete)) {
			onStreamComplete(); // call the callback when the streaming is finished
		}
	};

	const isScriptPresent = lib.isScriptPresent = function(srcPath) {
		const absoluteSrc = new URL(srcPath, window.location.href).href;
		const scripts = document.head.getElementsByTagName('script');
		for (let i = 0; i < scripts.length; i++) {
			if (scripts[i].src === absoluteSrc) {
				return true;
			}
		}
		return false;
	};

	const loadScriptLibrary = lib.loadScriptLibrary = function(srcPath, loadAsync) {
		return new Promise((resolve, reject) => {
			if (isScriptPresent(srcPath)) {
				resolve();
			}

			let scriptTag = document.createElement('script');
			scriptTag.src = srcPath;

			if (loadAsync) {
				scriptTag.async = true;
			}

			// Once the script is loaded, call the callback function
			scriptTag.onload = resolve;

			// Handle any errors that occur while loading the script
			scriptTag.onerror = function (error) {
				reject(new Error("Failed to load the library."));
			};

			// Append the script tag to the document's head to start loading the script
			document.head.appendChild(scriptTag);
		});
	};

	const copyToClipboard = lib.copyToClipboard = function(text) {
		if (navigator.clipboard && navigator.clipboard.writeText) {
			return navigator.clipboard.writeText(text);
		} else {
			// Fallback for older browsers
			const textarea = document.createElement('textarea');
			textarea.value = text;
			textarea.style.position = 'fixed';
			textarea.style.opacity = '0';
			document.body.appendChild(textarea);
			textarea.select();
			document.execCommand('copy');
			document.body.removeChild(textarea);
			return Promise.resolve();
		}
	};

	const notify = lib.notify = function(message, type) {
		// Check if jQuery is available
		if (typeof jQuery === 'undefined' || typeof jQuery.notify === 'undefined') {
			// Fallback to alert
			alert(message);
			return;
		}
		
		// Use jQuery Notify if available, otherwise use simple alert
		if (jQuery.notify) {
			jQuery.notify({
				message: message
			}, {
				type: type || 'info',
				placement: {
					from: 'bottom',
					align: 'right'
				},
				delay: 3000,
				timer: 1000,
				animate: {
					enter: 'animated fadeInUp',
					exit: 'animated fadeOutDown'
				}
			});
		}
	};

	root['util'] = lib;

	// Root will be `window` in browser or `global` on the server:
}(window));